<template>
  <div v-if="totalFeeCollection" class="head_fee_content py-4">
    <div class="head_fee_content_title">
      <h3>{{ title }}</h3>
      <span>{{ forceTotalAmountShown ? totalAmount : totalAmount ? totalAmount : totalFeeCollection | price }}</span>
    </div>
    <div class="price_wrap">
      <div v-for="(collection, index) in collections" :key="index">
        <div
          class="my-1 d-flex justify-space-between"
          :class="{ 'font-weight-bold': $_get(collection, 'style', '').includes('b') }"
        >
          <div>{{ index + 1 }}. {{ collection.name }}</div>
          <div>
            {{ collection.value | price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  computed: {
    totalFeeCollection() {
      let total = 0
      this.collections.forEach(item => {
        total += item.value
      })
      return total
    },
  },
  props: {
    title: String,
    totalAmount: Number,
    collections: {
      type: Object,
      default: () => ({}),
    },
    forceTotalAmountShown: Boolean,
  },

  data() {
    return {
      get,
    }
  },
}
</script>
<style lang="scss" scoped>
.head_fee_content {
  border-bottom: 1px solid #e0e0e0;
}

.collection-title {
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title {
  font-weight: 500;
  font-size: 16px;
  // line-height: 24px;
  color: #fd6b6b !important;
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title h3,
.head_fee_content_title span {
  color: #fd6b6b !important;
}

.note {
  display: block;
  max-width: 70% !important;
  color: #797979;
  margin-bottom: 6px;
  white-space: break-spaces;
}
</style>
